import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function MobileNav() {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Home', icon: '' },
    { path: '/transactions', label: 'Trans', icon: '' },
    { path: '/reports', label: 'Reports', icon: '' },

    { path: '/ai-assistant', label: 'AI', icon: '' },
    { path: '/settings', label: 'Settings', icon: '' }
  ];

  return (
    <nav className="mobile-nav">
      <ul className="mobile-nav-list">
        {navItems.map((item) => (
          <li key={item.path}>
            <Link
              to={item.path}
              className={`mobile-nav-link ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="mobile-nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default MobileNav;